module.exports = __webpack_public_path__ + "static/media/syrine-work-sample.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/designer-profiles/syrine-work-sample.png
// module id = 526
// module chunks = 0